import React from "react";

export default function FormSection({ label, children }) {
    return (
        <div className="pof-section">
            <span className="pof-section-label">{label}</span>
            {children}
        </div>
    );
}
